/**
 * WooCommerce quantity plus/minus buttons (rendered server-side by
 * inc/woocommerce/setup.php on single-product pages). Dispatches a native `change`
 * event so WooCommerce's own core scripts keep reacting to quantity updates.
 */
export function initQuantityButtons() {
	if ( ! document.body.classList.contains( 'single-product' ) ) {
		return;
	}

	document.addEventListener( 'click', ( event ) => {
		const button = event.target.closest( 'button.plus, button.minus' );

		if ( ! button ) {
			return;
		}

		const form = button.closest( 'form.cart' );
		const qty = form && form.querySelector( '.qty' );

		if ( ! qty ) {
			return;
		}

		const value = parseFloat( qty.value ) || 0;
		const max = parseFloat( qty.getAttribute( 'max' ) );
		const min = parseFloat( qty.getAttribute( 'min' ) );
		const step = parseFloat( qty.getAttribute( 'step' ) ) || 1;

		let next = value;

		if ( button.matches( '.plus' ) ) {
			next = ! isNaN( max ) && max <= value ? max : value + step;
		} else {
			if ( ! isNaN( min ) && min >= value ) {
				next = min;
			} else if ( value > 1 ) {
				next = value - step;
			}
		}

		qty.value = next;
		qty.dispatchEvent( new Event( 'change', { bubbles: true } ) );
	} );
}
